import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { submit } from 'redux-form';

import { EBON_BILLING_FORM_NAME } from '../../../constants/funnel';

import ButtonComponent from '../../button/ButtonComponent';
import PaymentLockLabel from '../../button/PaymentLockLabel';
import { LoadingComponent } from '../../loading/LoadingComponent';

/* Réutilise l'id du wrapper des boutons de paiement pour hériter de leurs styles :
   les deux ne sont jamais rendus en même temps (étapes différentes du funnel) */
const AddressSubmitButton = ({ i18nForm, isFetching, submit }) => {
    return (
        <div id="payment-selection-button-wrapper">
            {isFetching ? (
                <LoadingComponent />
            ) : (
                <ButtonComponent
                    color="main"
                    cssClass="nextStepButton"
                    text={i18nForm.VALIDATE_USER_DETAILS}
                    onClick={() => submit(EBON_BILLING_FORM_NAME)}
                />
            )}
            <PaymentLockLabel />
        </div>
    );
};

AddressSubmitButton.propTypes = {
    i18nForm: PropTypes.object,
    isFetching: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        i18nForm: state.i18n.feature.form,
        isFetching: state.ebon.lockFetching || state.ebon.createOrderRequest
    };
};

const mapDispatchToProps = {
    submit
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressSubmitButton);



// WEBPACK FOOTER //
// ./src/components/funnel/buttons/AddressSubmitButton.js